import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface RadioButtonProps {
  className?: string
  isSelected: boolean
  onClick?: () => void
  label?: React.ReactNode
  disabled?: boolean
  isHovered?: boolean
  id?: string
  showErrors?: boolean
  testId?: string
  'aria-label': string
}

const RadioButton: React.FC<RadioButtonProps> = (props): React.ReactElement => {
  return (
    <div
      id={props.id ? props.id + 'RadioButton' : 'radioButton'}
      data-testid={props.testId}
      className={props.className}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
      aria-label={props['aria-label']}
      css={css`
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          div {
            background-color: ${styleConstants.colors.white};
            border: 1px solid ${themeConstants.colors.cta};
          }
        }

        ${props.isSelected &&
        css`
          &:hover {
            div {
              background-color: ${themeConstants.colors.cta_dark};
              border: 1px solid ${themeConstants.colors.cta_dark};
            }
          }
        `}

        ${!!props.isHovered &&
        css`
          div {
            border: 1px solid ${themeConstants.colors.cta_dark};
            cursor: pointer;
          }
        `}

        ${!!props.disabled &&
        css`
          pointer-events: none;
          opacity: 50%;
        `}
      `}
    >
      <div
        className={'button'}
        css={css`
          height: 20px;
          width: 20px;
          border-radius: 50%;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
          border-radius: 10px;
          background-color: ${styleConstants.colors.gray_lightest};
          border: 1px solid ${styleConstants.colors.gray_medium};

          transition:
            border ${styleConstants.transitionSpeed.fast} ease-out,
            background-color ${styleConstants.transitionSpeed.fast} ease-out,
            box-shadow ${styleConstants.transitionSpeed.fast} ease-out;

          ${props.isSelected &&
          css`
            border: 1px solid ${themeConstants.colors.cta};
            background-color: ${themeConstants.colors.cta};
            box-shadow: inset 0px 0px 0px 1px ${styleConstants.colors.white};
          `}

          ${!!props.showErrors &&
          css`
            border: 1px solid ${styleConstants.colors.red};
          `}
        `}
      />
      {props.label !== undefined && (
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-left: 10px;
          `}
        >
          {props.label}
        </span>
      )}
    </div>
  )
}

export default RadioButton
